import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import DashboardLayout from '../components/DashboardLayout';
import { Navigate } from 'react-router-dom';
import './Dashboard.css';

const adminNavigationItems = [
	{
		name: 'Create Organization',
		icon: 'add_business',
		path: '/dashboard/admin/organization/create',
		description: 'Create a new organization in the system',
	},
	{
		name: 'Manage Organizations',
		icon: 'business',
		path: '/dashboard/admin/organizations',
		description: 'View and manage all organizations',
	},
	{
		name: 'System Settings',
		icon: 'settings',
		path: '/dashboard/admin/settings',
		description: 'Configure global system settings',
	},
	{
		name: 'User Management',
		icon: 'manage_accounts',
		path: '/dashboard/admin/users',
		description: 'Manage system-wide user accounts',
	},
];

function DashboardAdmin() {
	const { orgData, userData } = useAuth();
	const primaryColor = orgData?.primaryColor || '#4b95a3';

	// Redirect if not a SuperAdmin
	if (userData?.accessLevel !== 'SuperAdmin') {
		return <Navigate to='/dashboard' />;
	}

	const sidebarStyle = {
		'--primary-color': primaryColor,
		'--primary-color-light': `${primaryColor}1A`,
	};

	return (
		<DashboardLayout>
			<div className='dashboard-page'>
				<h1>System Administration</h1>
				<div className='dashboard-grid'>
					{adminNavigationItems.map((item) => (
						<Link
							key={item.name}
							to={item.path}
							className='dashboard-card'
							style={sidebarStyle}>
							<span className='material-icons card-icon'>
								{item.icon}
							</span>
							<h3>{item.name}</h3>
							<p>{item.description}</p>
						</Link>
					))}
				</div>
			</div>
		</DashboardLayout>
	);
}

export default DashboardAdmin;
